// PageHeader component:
// defaults to player name and position
// if any custom title is supplied this will override any team or player titleType prop.
// if no children are supplied, the default will be a two column layout
// if children are supplied, the default will be a three column layout
// A titleType == BLANK will display a two column child layout,
import React from 'react';
import PropTypes from 'prop-types';
import { useReactiveVar } from '@apollo/client';
import { mf_PlayerDetails, mf_TeamDetails, mf_Teams } from '../../apollo';
import {
  Breadcrumb,
  BreadcrumbSection,
  BreadcrumbDivider,
  InfoBar,
  PageHeaderTile,
} from './PageHeader.styles';
import ParsedLink from '../ParsedLink/ParsedLink';
import { PAGE_HEADER_DISPLAY } from './PageHeader.constants';
import GameTeamsLine from './GameTeamsLine';

const PageHeader = ({
  href = '',
  rootPage = '',
  activePage = '',
  titleType = PAGE_HEADER_DISPLAY.PLAYER,
  customTitle = '',
  children = null,
  margin = null,
  game = null,
  __storybookPlayerDetails,
  __storybookTeamDetails,
  __storybookSelectedTeamId,
}) => {
  const mf_PlayerDetailsRV =
    __storybookPlayerDetails || useReactiveVar(mf_PlayerDetails);
  const mf_TeamDetailsRV =
    __storybookTeamDetails || useReactiveVar(mf_TeamDetails);
  const mf_TeamsRV = useReactiveVar(mf_Teams);
  const selectedTeamId = __storybookSelectedTeamId ?? mf_TeamsRV;
  const { mostCommonPosition: position } = mf_PlayerDetailsRV || {};
  const playerNameAndPosition =
    mf_PlayerDetailsRV &&
    `${mf_PlayerDetailsRV?.name || ''} ${
      (mf_PlayerDetailsRV?.name && '-') || ''
    } ${position?.name || ''}`;
  const teamName = mf_TeamDetailsRV?.name;
  const { CUSTOM, PLAYER, TEAM, BLANK, GAME } = PAGE_HEADER_DISPLAY;
  const displayType = customTitle.length > 0 ? CUSTOM : titleType;

  return (
    <PageHeaderTile $margin={margin}>
      <InfoBar $cols={children && displayType !== BLANK ? 3 : 2}>
        <div>
          {rootPage && (
            <Breadcrumb>
              <BreadcrumbSection>
                <ParsedLink href={href}>{rootPage}</ParsedLink>
              </BreadcrumbSection>
              <BreadcrumbDivider>/</BreadcrumbDivider>
              <BreadcrumbSection>{activePage}</BreadcrumbSection>
            </Breadcrumb>
          )}
        </div>

        {displayType === PLAYER && (
          <div>
            <h3>{playerNameAndPosition}</h3>
          </div>
        )}

        {displayType === TEAM && (
          <div>
            <h3>{teamName}</h3>
          </div>
        )}
        {displayType === CUSTOM && (
          <div>
            <h3>{customTitle}</h3>
          </div>
        )}

        {displayType === GAME && game?.homeTeam && game?.awayTeam && (
          <div>
            <GameTeamsLine game={game} selectedTeamId={selectedTeamId} />
          </div>
        )}

        {children && <div className="children">{children}</div>}
      </InfoBar>
    </PageHeaderTile>
  );
};

PageHeader.propTypes = {
  href: PropTypes.string,
  rootPage: PropTypes.string,
  activePage: PropTypes.string,
  titleType: PropTypes.oneOf(Object.values(PAGE_HEADER_DISPLAY)),
  customTitle: PropTypes.string,
  children: PropTypes.node,
  margin: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  game: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  __storybookPlayerDetails: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  __storybookTeamDetails: PropTypes.object,
  __storybookSelectedTeamId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default PageHeader;
